<template>
  <div class="DiaryView" v-if="diaryEntry && currentProject._id">
    <div class="diaryContainer">
      <div class="top">
        <div>
          <h2 style="font-weight: normal">> {{ $t('Diary') }}<debug :object="diaryEntry" /></h2>
        </div>
        <router-link :to="{ name: 'ProjectPlanEdit', params: { _id: currentProject._id }, query: $route.query }">
          <button class="modal-close-button">
            <b-icon icon="x" />
          </button>
        </router-link>
      </div>
      <div class="user" v-if="!diaryEntry.signedOff">
        ⚠️ {{ $t('This diary entry is not yet signed!') }}
        <br />
        <br />
      </div>
      <DiarySummary :diaryEntry="diaryEntry" :projectCity="projectCity" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DiarySummary from '@/components/diary/DiarySummary.vue';

export default {
  name: 'DiaryView',
  props: ['diaryEntry', 'projectCity'],
  computed: {
    ...mapGetters(['currentProject']),
  },
  components: {
    DiarySummary,
  },
};
</script>

<style scoped>
/* @font-face {
    font-family: 'Montserrat-ThinItalic';
    src: local('Montserrat-ThinItalic'), local('Montserrat-ThinItalic'), url(/static/fonts/Montserrat-ThinItalic.ttf) format('ttf');
  } */
@import url('https://fonts.googleapis.com/css?family=Cabin:400,500,500i,600,700|Montserrat+Alternates|Montserrat:300,300i,400,500,600,600i&display=swap" rel="stylesheet');
.DiaryView {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 100px);
  padding: 0 20px;
  color: #fff;
}

.diaryContainer {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 15px;
}

.top img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.diaryContainer .title {
  font-size: 18px;
  font-weight: 100;
  margin-bottom: 5px;
}

.titles {
  padding-top: 10px;
}

.total-count {
  font-size: 14px;
  padding: 20px 0;
  border-bottom: 1px solid #253747;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
}
.total-count span {
  font-size: 11px;
  font-weight: normal;
}
.comment-list {
  /* max-height: 300px;
    overflow-y: scroll;
    overflow-x: hidden; */
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #253747;
}
.comment-list ul {
  list-style: none;
}
.comment-list ul li {
  font-size: 14px;
  margin-bottom: 10px;
  /* font-family: Montserrat; */
  font-weight: 400;
  max-height: 400px;
}
.comment-list ul li .comment {
  display: block;
  font-size: 12px;
  margin-top: 3px;
  font-family: Cabin !important;
  font-weight: normal;
  color: #d1d3d4;
}
.other-text {
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #253747;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}
.other-text span {
  font-size: 11px;
  font-weight: 200;
  font-style: italic;
  color: #fff;
}
.other-text p {
  font-size: 12px;
  font-weight: 200;
  color: #fff;
}
.user {
  margin-top: 15px;
  text-align: center;
}
.user p {
  font-size: 14px;
  font-weight: 100;
  font-family: 'Montserrat', sans-serif;
  font-style: italic;
}

.current-day {
  display: flex;
  margin-bottom: 10px;
}

.current-day .light {
  font-weight: lighter;
  margin-right: 5mm;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/DiaryView.vue